import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { QrReader } from 'react-qr-reader';
import Swal from 'sweetalert2'

import { solicitudActions } from '../redux/solicitud/actions'

export const About = (props) => {

  const dispatch = useDispatch();
  const [visible, setVisible] = React.useState(false)
  const [visibleButton, setVisibleButton] = React.useState(false)
  const [data, setData] = React.useState('');

  const rosetaInfo = useSelector(
    (state) => state.solicitud.rosetaInfo
  );

  const handleVerification = () => {
    setVisible(true)
  }

  const handleScanner = () => {
    setVisibleButton(true);
    setData('')
  }

  const handleCancel = () => {
    setVisible(false);
    dispatch(solicitudActions.clearRosetaInfo());
  }

  React.useEffect(() => {
    if (data.length > 0) {
      dispatch(solicitudActions.readRosetaRequest(data))
      setVisibleButton(false);
    }
  }, [data, dispatch])

  const handleSeguimiento = () => {
    Swal.fire({
      title: 'Introduzca su CÓDIGO de solicitud o número de PLACA',
      input: 'text',
      inputAttributes: {
        autocapitalize: 'off'
      },
      showCancelButton: true,
      cancelButtonText: 'Cancelar',
      confirmButtonText: 'Buscar',
      showLoaderOnConfirm: true,
      allowOutsideClick: false,
      inputValidator: (solCod) => {
        if (!solCod) {
          return 'Debe ingresar el codigo de solicitud!'
        }
      },
      preConfirm: (solCod) => {
        let codFormated = solCod.toUpperCase()
        dispatch(solicitudActions.verifySolicitudStateRequest(codFormated));
      },
    })
  };

  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const fechaCaducidad = rosetaInfo?.fechaCaducidad 
    ? new Date(rosetaInfo.fechaCaducidad) 
    : null;
  if (fechaCaducidad) {
    fechaCaducidad.setHours(0, 0, 0, 0);
  }
  const isExpired = fechaCaducidad && fechaCaducidad.getTime() <= today.getTime();
  const imageSrc =
    rosetaInfo?.estado === "deprecated" || isExpired
      ? "img/newDeprecated.png"
      : "img/newautorizado.jpg";
  return (
    <div id="about" style={{ padding: 0 }}>
      <div className="container">
        <div className="row text-center" style={{paddingTop:"15px", paddingBottom:"35px"}}>
          <div style={{paddingBottom:"12px"}}>
            <h2>Seguimiento</h2>
            <button type="button" className="btn btn-custom" onClick={handleSeguimiento}>
              <i class="fa fa-search" aria-hidden="true"></i>
              SEGUIMIENTO
            </button>

            <div className="modal fade" id="exampleModal" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
              <div className="modal-dialog" role="document">
                <div className="modal-content">
                  <div className="modal-header">
                    {/* <h3 style={{display: 'flex', justifyContent: 'center'}} className="modal-title" id="exampleModalLabel">Verificación de Roseta</h3> */}
                    <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={handleCancel}>
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                  <div className="modal-body">
                    {
                      !visibleButton ? (
                        <div style={{ display: 'flex', justifyContent: 'center', width: "auto" }}>
                          {/* <button className="btn btn-primary" onClick={handleScanner}> <img src="img/qr.png" style={{ borderRadius : '10%', height:"20px", width:"auto"}}className="img-responsive" alt="" /> Lectura de QR</button> */}
                          <button className="btn btn-primary" onClick={handleScanner}> <i className='fa fa-qrcode'></i> Lectura de QR</button>
                        </div>
                      ) : (
                        <div>
                          <QrReader
                            scanDelay={300}
                            constraints={{ facingMode: 'environment' }}
                            onResult={(result, error) => {
                              if (!!result) {
                                setData(result?.text)
                                // setVisibleButton(false)
                              }
                              // if (!!error) {
                              //   console.info(error);
                              // }
                            }}
                            style={{ width: '100%' }}
                          />
                        </div>
                      )
                    }
                    <br />
                    {rosetaInfo && !rosetaInfo.message ? (
                      <>
                        <div id="services" className='text-center'>
                          <div >
                            <h3 style={{ textAlign: "center", marginBottom: "0px" }}>{rosetaInfo.tipoRoseta}</h3>
                            <div>
                            <img
                              src={imageSrc} 
                              style={{ borderRadius: "10%", marginTop: "2rem" }} 
                              alt={imageSrc === "img/newDeprecated.png" ? "Caducada" : "Autorizada"} 
                            />
                            </div>
                          </div>
                        </div>
                        <div id="about" >
                          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'space-between' }}>
                            <div className='col sm-12 md-6'>
                              <p style={{ fontSize: "26px" }}><h4>Placa: </h4>{rosetaInfo.placa}</p>
                              <p style={{ fontSize: "26px" }}><h4>Color: </h4>{rosetaInfo.color}</p>
                            </div>
                            <div className='col sm-12 md-6' style={{ paddingLeft: "70px" }}>
                              <p style={{ fontSize: "26px" }}><h4>Marca: </h4>{rosetaInfo.marca}</p>
                              <p style={{ fontSize: "26px" }}><h4>Año: </h4>{rosetaInfo.anio}</p>
                            </div>
                          </div>
                        </div>
                      </>
                    ) : null}
                    {rosetaInfo && rosetaInfo.message ? (
                      <>
                        <div id="services2" className='text-center' >
                          {/* <div className='section-title'>
                        <h2 >ROSETA INVÁLIDA</h2>
                      </div> */}
                          <div>
                          {rosetaInfo.error ? <img src="img/noIdentificada.jpg" style={{ borderRadius: '10%' }} className="img-responsive" alt="Roseta No Identificada" /> 
                          : <img src="img/noVinculada.jpg" style={{ borderRadius: '10%' }} className="img-responsive" alt="No Vinculada" />}
                          </div>
                        </div>

                        <div id="about" style={{ display: 'flex', justifyContent: 'center', alignItems: 'space-between' }}>
                          <h3><b>{rosetaInfo.message}</b></h3>
                        </div>
                      </>
                    ) : null}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div>
            <h2>VERIFICAR QR</h2>
            <button type="button" className="btn btn-custom" data-toggle="modal" data-target="#exampleModal" onClick={handleVerification}>
              <i class="fa fa-qrcode" aria-hidden="true"></i>
              ESCANEAR ROSETA
            </button>
          </div>
        </div>
        <div className="row">
            <div className="col-xs-12 col-md-6">
              {" "}
              <img src="img/aboutNew2.jpg" style={{ borderRadius: '10%' }} className="img-responsive" alt="" />{" "}
            </div>
            <div className="col-xs-12 col-md-6">
              <div className="about-text">
                <h2>Propósito</h2>
                <p style={{ textAlign: 'justify' }}>{props.data ? props.data.paragraph : "loading..."}</p>
                {/* <p>{props.data ? props.data.paragraph2 : "loading..."}</p> */}
                <h3>Objetivos Específicos</h3>
                <div className="list-style">
                  <div className="col-lg-6 col-sm-6 col-xs-12">
                    <ul style={{ textAlign: 'justify' }}>
                      {props.data
                        ? props.data.Why.map((d, i) => (
                          <li key={`${d}-${i}`}>{d}</li>
                        ))
                        : "loading"}
                    </ul>
                  </div>
                  <div className="col-lg-6 col-sm-6 col-xs-12">
                    <ul>
                      {props.data
                        ? props.data.Why2.map((d, i) => (
                          <li key={`${d}-${i}`}> {d}</li>
                        ))
                        : "loading"}
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
      </div>
    </div>
  );
};
